// AUTO-GENERATED by scripts/gen-build-info.js — do not edit.
export const BUILD_INFO = { sha: '015882d9', builtAt: '2026-11-04 18:53 UTC' };
